import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import heroImage from "../assets/construction2.png";

const contactCards = [
  {
    label: "E-mail",
    value: "Smarttgmtz@gmail.com",
    href: "mailto:Smarttgmtz@gmail.com",
  },
  {
    label: "Telephone",
    value: "+255 789 500 326",
    href: "tel:+255789500326",
  },
  {
    label: "Mobile",
    value: "+255 714 993 677 / +255 715 687 979",
    href: "tel:+255714993677",
  },
];

export default function ContactUsContent() {
  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Speak with SMART TGM Limited about your next construction need."
        text="Reach the team for civil works, building construction, project management, technical support, and specialized construction scopes."
        image={heroImage}
      />

      <section className="tgm-section tgm-contact-page" data-aos="fade-up">
        <div className="container">
          <div className="tgm-contact-layout">
            <div className="tgm-contact-intro">
              <p className="tgm-section-kicker">Dar es Salaam Office</p>
              <h2>Vijana House, Plot No. 08, Block 33A.</h2>
              <p>
                Mwananyamala A, Kinondoni, Dar es Salaam. Send your project
                scope, service inquiry, or consultation request and the team
                will follow up.
              </p>
            </div>

            <div className="tgm-contact-card-grid">
              {contactCards.map((card) => (
                <a className="tgm-contact-card" href={card.href} key={card.label}>
                  <span>{card.label}</span>
                  <strong>{card.value}</strong>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}
